import React from "react";
import { ReactNode } from "react";

interface TelefoneActionsProps {
  children?: ReactNode;
}

export function TelefoneActions({ children }: TelefoneActionsProps) {
  return <div className="mt-4 flex w-full justify-around gap-2  self-center">{children}</div>;
}
